import { BaseSensor } from './BaseSensor';
import { Device } from './Device';
import { TimeFrameManager } from './TimeFrameManager';
import { DataIoService } from '../services/data-io.service';
export class ZeitprogrammAssistent extends Device{

	timeframeManager:TimeFrameManager;
	ioService : DataIoService;
	setIoService(ioService:DataIoService){
		this.ioService = ioService;
	}
	constructor(id:number){
		super(id);
		this.id=id;


		
		this.scales = new Map<string,BaseSensor>();
		this.scales.set("wunschtemperatur",BaseSensor.fromArgs("wunschtemperatur",20,5,30,0.5,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.timeframeManager = new TimeFrameManager();
		
		let name=".";

		let begin = new Date();
		begin.setHours(9);
		begin.setMinutes(0);
		let end = new Date();
		end.setHours(11);
		end.setMinutes(0);
		for(let day=0;day<5;day++){
			this.timeframeManager.addTimeFrameByArgs(day,begin,end,20,name);			
		}
		begin.setHours(7);
		begin.setMinutes(30);
		end.setHours(23);
		end.setMinutes(30);
		this.timeframeManager.addTimeFrameByArgs(5,begin,end,20,name);
		end.setHours(22);
		end.setMinutes(0);
		this.timeframeManager.addTimeFrameByArgs(6,begin,end,20,name);
		//console.log("Adding timeframemanager for "+name);
	}

	getFrameManager():TimeFrameManager{
		return this.timeframeManager;
	}

	apply(){
		let di = this.ioService.deviceInfo();
		let zoneIds = di.getZoneIds();

		for(let day of [0,1,2,3,4,5,6]){
			for(let zoneId of zoneIds){
				let zone = di.getZoneById(zoneId);
				let names = zone.getTimeFrameNames();
				for(let name of names){
					let frameManager = zone.getTimeFrameManager(name);
					frameManager.clearDay(day);
					for(let frame of this.timeframeManager.getTimeFrames(day)){
						//console.log("Adding frame "+frame.toString(true)+ " for day "+day + " to timeFrameManager " + name + " on zone "+ zoneId);
						if(zoneId == 1){
							frameManager.addTimeFrame(frame);
						}
					}
				}
			}
		}
	}
}